import { useTranslation } from 'react-i18next';

export function useTutorialSteps(user?: { is_admin?: boolean }) {
    const { t,  i18n } = useTranslation();
    const lang = i18n.language;

    // Helper function to get image path based on language
    const imgPath = (filename: string) =>
        lang === 'en'
            ? `/images/en/${filename}`
            : `/images/fr/${filename}`;

    const steps = [
        {
            label: (
                <span style={{ fontSize: '2rem', fontWeight: 700, display: 'block', textAlign: 'center' }}>
                {t('tutorial.addSensor')}
                </span>
            ),
            description: (
                <div className="tutorial-images">
                    <img
                    src={imgPath('ajouterCapteur.png')}
                    alt={t('tutorial.addSensor') ?? 'Add sensor'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                    <img
                    src={imgPath('entrerCapteur.png')}
                    alt={t('tutorial.enterSensor') ?? 'Enter sensor'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                </div>
            ),
            adminOnly: false,
        },
        {
            label: (
                <span style={{ fontSize: '2rem', fontWeight: 700, display: 'block', textAlign: 'center' }}>
                {t('tutorial.acknowledgeAlert')}
                </span>
            ),
            description: (
                <div className="tutorial-images">
                    <img
                    src={imgPath('acquitterOption.png')}
                    alt={t('tutorial.acknowledgeAlertOption') ?? 'Acknowledge alert option'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                    <img
                    src={imgPath('acquitter.png')}
                    alt={t('tutorial.acknowledgeAlert') ?? 'Acknowledge alert'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                </div>
            ),
            adminOnly: false,
        },
        {
            label: (
                <span style={{ fontSize: '2rem', fontWeight: 700, display: 'block', textAlign: 'center' }}>
                {t('tutorial.deleteAlert')}
                </span>
            ),
            description: (
                <div className="tutorial-images">
                    <img
                    src={imgPath('supprimerOption.png')}
                    alt={t('tutorial.deleteAlertOption') ?? 'Delete alert option'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                    <img
                    src={imgPath('supprimer.png')}
                    alt={t('tutorial.deleteAlert') ?? 'Delete alert'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                </div>
            ),
            adminOnly: true,
        },
        {
            label: (
                <span style={{ fontSize: '2rem', fontWeight: 700, display: 'block', textAlign: 'center' }}>
                {t('tutorial.defineLocation')}
                </span>
            ),
            description: (
                <div className="tutorial-images">
                    <img
                    src={imgPath('definirEmplacement.png')}
                    alt={t('tutorial.defineLocation') ?? 'Define location'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                    <img
                    src={imgPath('enregistrerEmplacement.png')}
                    alt={t('tutorial.saveLocation') ?? 'Save location'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                </div>
            ),
            adminOnly: false,
        },
        {
            label: (
                <span style={{ fontSize: '2rem', fontWeight: 700, display: 'block', textAlign: 'center' }}>
                {t('tutorial.createUser')}
                </span>
            ),
            description: (
                <div className="tutorial-images">
                    <img
                    src={imgPath('creerUtilisateur.png')}
                    alt={t('tutorial.createUser') ?? 'Create user'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                    <img
                    src={imgPath('enregistrerUtilisateur.png')}
                    alt={t('tutorial.saveUser') ?? 'Save user'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                </div>
            ),
            adminOnly: true,
        },
        {
            label: (
                <span style={{ fontSize: '2rem', fontWeight: 700, display: 'block', textAlign: 'center' }}>
                {t('tutorial.changeFullName')}
                </span>
            ),
            description: (
                <div className="tutorial-images">
                    <img
                    src={imgPath('changerNomComplet.png')}
                    alt={t('tutorial.changeFullName') ?? 'Change full name'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                    <img
                    src={imgPath('enregistrerNomComplet.png')}
                    alt={t('tutorial.saveFullName') ?? 'Save full name'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                </div>
            ),
            adminOnly: true,
        },
        {
            label: (
                <span style={{ fontSize: '2rem', fontWeight: 700, display: 'block', textAlign: 'center' }}>
                {t('tutorial.changePassword')}
                </span>
            ),
            description: (
                <div className="tutorial-images">
                    <img
                    src={imgPath('changerMdp.png')}
                    alt={t('tutorial.changePassword') ?? 'Change password'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                    <img
                    src={imgPath('enregistrerMdp.png')}
                    alt={t('tutorial.savePassword') ?? 'Save password'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                </div>
            ),
            adminOnly: true,
        },
        {
            label: (
                <span style={{ fontSize: '2rem', fontWeight: 700, display: 'block', textAlign: 'center' }}>
                {t('tutorial.changeRole')}
                </span>
            ),
            description: (
                <div className="tutorial-images">
                    <img
                    src={imgPath('changerRole.png')}
                    alt={t('tutorial.changeRole') ?? 'Change role'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                    <img
                    src={imgPath('enregistrerRole.png')}
                    alt={t('tutorial.saveRole') ?? 'Save role'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                </div>
            ),
            adminOnly: true,
        },
        {
            label: (
                <span style={{ fontSize: '2rem', fontWeight: 700, display: 'block', textAlign: 'center' }}>
                {t('tutorial.deleteUser')}
                </span>
            ),
            description: (
                <div className="tutorial-images">
                    <img
                    src={imgPath('supprimerUtilisateur.png')}
                    alt={t('tutorial.deleteUser') ?? 'Delete user'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                    <img
                    src={imgPath('confirmerSuppression.png')}
                    alt={t('tutorial.confirmDeletion') ?? 'Confirm deletion'}
                    style={{ maxWidth: '50%', marginBottom: 16, borderRadius: 8 }}
                    />
                </div>
            ),
            adminOnly: true,
        },
    ];

    // Filter steps based on user role
    return steps.filter(
    (step) => !step.adminOnly || (user && user.is_admin)
    );
}